module.exports = __webpack_public_path__ + "static/media/login-bg.85143809.jpg";